import axios from 'axios';

const API_BASE_URL = '/api/quickbooks';

export interface Connection {
  id: number;
  connectionName: string | null;
  companyId: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export const getConnections = async (): Promise<Connection[]> => {
  const response = await axios.get<Connection[]>(`${API_BASE_URL}/status`);
  return response.data;
};

export const connectAccount = (onSuccess: () => void) => {
  const width = 600, height = 700;
  const left = (window.innerWidth - width) / 2;
  const top = (window.innerHeight - height) / 2;
  const url = `${process.env.REACT_APP_BACKEND_HOST_URL}${API_BASE_URL}/connect`;
  const options = `width=${width},height=${height},top=${top},left=${left}`;
  const popup = window.open(url, 'QuickBooksOAuth', options);

  const handleMessage = (event: MessageEvent) => {
    if (event.origin === process.env.REACT_APP_BACKEND_HOST_URL && event.data === 'oauth:success') {
      if (popup) popup.close();
      window.removeEventListener('message', handleMessage);
      onSuccess();
    }
  };

  window.addEventListener('message', handleMessage, false);
};

export const removeConnection = async (id: number): Promise<void> => {
  await axios.delete(`${API_BASE_URL}/${id}`);
};
